import * as XLSX from 'xlsx';

export const exportToExcel = (data, fileName = 'export.xlsx', sheetName = 'Sheet1') => {
    // Create a new workbook
    const wb = XLSX.utils.book_new();
    
    // Convert data to worksheet
    const ws = XLSX.utils.json_to_sheet(data);
    
    // Set column widths
    const colWidths = Object.keys(data[0]).map(key => ({
        wch: Math.max(
            key.length, // Header width
            ...data.map(row => String(row[key]).length) // Data width
        ) + 2 // Add some padding
    }));
    ws['!cols'] = colWidths;
    
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(wb, ws, sheetName);
    
    // Generate Excel file and trigger download
    XLSX.writeFile(wb, fileName);
};

// Helper function to format date
export const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return '';
    const pad = (n) => String(n).padStart(2, '0');
    const day = pad(d.getDate());
    const month = pad(d.getMonth() + 1);
    const year = d.getFullYear();
    return `${month}/${day}/${year}`;
};

// Helper function to format currency
export const formatCurrency = (amount) => {
    if (amount === null || amount === undefined) return 'N/A';
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'EGP'
    }).format(amount);
}; 